import { Event } from './../../models/events/events.model';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';

@Injectable()
export class EventsProvider {

  public eventListRef = this.db.list<Event>('/meets');

  constructor(private db: AngularFireDatabase) { }

  getEventList() {
    return this.eventListRef;
  }

  addEvent(event: Event) {
    return this.eventListRef.push(event);
  }
}



// WEBPACK FOOTER //
// ./src/providers/events/events.service.ts